module.exports = __webpack_public_path__ + "static/media/bgaboutus2mb.a54bcffd.png";